function getLocale() {
    try {
        let language = window.navigator.userLanguage || window.navigator.language;
        if (language) {
            return language;
        }

        return "en-US";
    } catch (err) {
        return "en-US";
    }
}

function nFormatter(numFloat, digits) {
    let num = parseFloat(numFloat);
    let si = [
        { value: 1, symbol: "" },
        { value: 1E3, symbol: "K" },
        { value: 1E6, symbol: " M" },
        { value: 1E9, symbol: " B" }
    ];
    let rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    let i;
    for (i = si.length - 1; i > 0; i--) {
        if (num >= si[i].value) {
            break;
        }
    }
    return (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
}


function formatPrice(price, fractionDigits = 4) {
    if (price >= 10) {
        fractionDigits = 2;
    }

    if (price >= 100) {
        fractionDigits = 1;
    }

    if (price >= 1000) {
        fractionDigits = 0;
    }

    let formatter = new Intl.NumberFormat(getLocale(), {
        style: 'decimal',
        maximumFractionDigits: fractionDigits,
    });

    return formatter.format(price);
}

function formatAndRound(price, fractionDigits = 0) {
    let formatter = new Intl.NumberFormat(getLocale(), {
        style: 'decimal',
        maximumFractionDigits: fractionDigits,
    });

    return formatter.format(price);
}


let Price = {
    locale: getLocale,
    format: formatPrice,
    formatRound: formatAndRound,
    formatLargeNumber: nFormatter
};

export default Price;



// WEBPACK FOOTER //
// ./src/Price.js